import { WsError } from '@gem/modules/wsClient/wsErrors';

export enum WsCallsErrorCode {
  BadData = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
}

export class WsCallsApiError extends WsError {
  constructor(public code: WsCallsErrorCode, public message: string) {
    super(code, message);
  }
}
